<script setup lang="ts">
import { useAssistantSettingsStore } from "@/stores/assistantSettingsStore";

const { assistantSettings } = useAssistantSettingsStore();
</script>

<template>
  <footer class="auth-footer">
    <PoweredBy v-if="assistantSettings.config.has_branding"></PoweredBy>
  </footer>
</template>

<style lang="scss" scoped>
.auth-footer {
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 4rem;
}
</style>
